(function () {
  function qs(root, sel) {
    return (root || document).querySelector(sel);
  }

  function initEditor(root) {
    const openBtn = qs(root, '[data-ff-open]');
    const modal = qs(root, '[data-ff-modal]');
    const backdrop = qs(root, '[data-ff-backdrop]');
    const closeBtn = qs(root, '[data-ff-close]');

    const fileInput = qs(root, '[data-ff-file]');
    const borderOn = qs(root, '[data-ff-border-on]');
    const borderMm = qs(root, '[data-ff-border-mm]');
    const borderMmVal = qs(root, '[data-ff-border-mm-val]');
    const borderColor = qs(root, '[data-ff-border-color]');

    const addBtn = qs(root, '[data-ff-add]');
    const note = qs(root, '[data-ff-note]');

    const canvas = qs(root, '#ffCanvas');
    const ctx = canvas.getContext('2d');

    let img = null;

    function isAllowedFile(file) {
  if (!file) return false;

  const name = (file.name || '').toLowerCase();

  // mime types
  const okMime =
    file.type === 'image/png' ||
    file.type === 'image/svg+xml';

  // fallback: extensie (soms is file.type leeg)
  const okExt =
    name.endsWith('.png') ||
    name.endsWith('.svg');

  return okMime || okExt;
}

    function openModal() {
      modal.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function clearCanvas() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = '#bfbfbf';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
    }

    // --- HELPERS: contour/die-cut border op basis van alpha ---
    function tintImageToColor(image, color) {
      const c = document.createElement('canvas');
      c.width = image.width;
      c.height = image.height;
      const cctx = c.getContext('2d');

      // draw original
      cctx.clearRect(0, 0, c.width, c.height);
      cctx.drawImage(image, 0, 0);

      // keep alpha, replace color
      cctx.globalCompositeOperation = 'source-in';
      cctx.fillStyle = color;
      cctx.fillRect(0, 0, c.width, c.height);

      // reset
      cctx.globalCompositeOperation = 'source-over';
      return c;
    }

    function drawContourBorder(ctx2, tintedCanvas, x, y, w, h, radiusPx) {
      // radiusPx = outline dikte in px (preview)
      // steps bepaalt hoe rond/strak de outline is
      const steps = Math.max(12, Math.min(48, Math.round(radiusPx * 6)));
      for (let i = 0; i < steps; i++) {
        const a = (i / steps) * Math.PI * 2;
        const dx = Math.cos(a) * radiusPx;
        const dy = Math.sin(a) * radiusPx;
        ctx2.drawImage(tintedCanvas, x + dx, y + dy, w, h);
      }
    }

    function draw() {
      clearCanvas();
      if (!img) return;

      // mm->px alleen voor preview (subtieler)
      const mmToPx = 2.5;

      const borderPx = borderOn.checked ? (parseFloat(borderMm.value) * mmToPx) : 0;

      const pad = 80;
      const maxW = canvas.width - pad * 2;
      const maxH = canvas.height - pad * 2;

      const safeW = Math.max(10, maxW - borderPx * 2);
      const safeH = Math.max(10, maxH - borderPx * 2);

      const scale = Math.min(safeW / img.width, safeH / img.height);

      const w = img.width * scale;
      const h = img.height * scale;

      const cx = canvas.width / 2;
      const cy = canvas.height / 2;

      const x = cx - w / 2;
      const y = cy - h / 2;

      // contour border (werkt het beste met PNG/SVG met transparantie)
      if (borderPx > 0) {
        const tinted = tintImageToColor(img, borderColor.value);
        drawContourBorder(ctx, tinted, x, y, w, h, borderPx);
      }

      // originele afbeelding bovenop
      ctx.drawImage(img, x, y, w, h);
    }

    function setLabels() {
      borderMmVal.textContent = borderMm.value;
    }

    function loadImage(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const image = new Image();
          image.onload = () => resolve(image);
          image.onerror = reject;
          image.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    }

    function getProductForm() {
      return document.querySelector('form[action*="/cart/add"]');
    }

    function ensureHidden(form, name, value) {
      let input = form.querySelector(`input[name="${CSS.escape(name)}"]`);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        form.appendChild(input);
      }
      input.value = value;
    }

    async function addToCart() {
      const form = getProductForm();
      if (!form) {
        note.textContent = 'Product form niet gevonden.';
        return;
      }

      
      const file = fileInput.files && fileInput.files[0];
if (!file) {
  note.textContent = 'Upload eerst een bestand.';
  return;
}

if (!isAllowedFile(file)) {
  note.textContent = 'Alleen PNG of SVG toegestaan.';
  return;
}

      // line item properties
      ensureHidden(form, 'properties[Border]', borderOn.checked ? 'Ja' : 'Nee');
      ensureHidden(form, 'properties[Border breedte (mm)]', borderMm.value);
      ensureHidden(form, 'properties[Border kleur]', borderColor.value);

      // voeg file input toe aan de form zodat Shopify hem meeneemt
      if (!fileInput.closest('form')) {
        form.appendChild(fileInput);
      }

      addBtn.disabled = true;
      note.textContent = 'Toevoegen aan winkelwagen...';

      // Zorg dat de form multipart submit gebruikt (nodig voor files)
form.setAttribute('enctype', 'multipart/form-data');
form.setAttribute('encoding', 'multipart/form-data');

// BELANGRIJK: gebruik form.submit() i.p.v. requestSubmit()
// form.submit() omzeilt theme JS die vaak AJAX /cart/add.js gebruikt (dat kan geen file upload)
form.submit();

      closeModal();
    }

    // events
    openBtn.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    backdrop.addEventListener('click', closeModal);

    borderOn.addEventListener('change', draw);
    borderMm.addEventListener('input', () => {
      setLabels();
      draw();
    });
    borderColor.addEventListener('change', draw);

    fileInput.addEventListener('change', async () => {
  const file = fileInput.files && fileInput.files[0];
  if (!file) return;

  // reset state
  img = null;
  addBtn.disabled = true;

  // validatie
  if (!isAllowedFile(file)) {
    note.textContent = 'Alleen PNG of SVG toegestaan.';
    fileInput.value = '';
    clearCanvas();
    return;
  }

  note.textContent = 'Bezig met laden...';

  try {
    img = await loadImage(file);
    setLabels();
    draw();
    addBtn.disabled = false;
    note.textContent = '';
  } catch (e) {
    img = null;
    addBtn.disabled = true;
    note.textContent = 'Bestand kon niet worden ingeladen.';
    clearCanvas();
  }
});

    addBtn.addEventListener('click', addToCart);

    // init
    setLabels();
    clearCanvas();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-ff-editor]').forEach(initEditor);
  });
})();
